import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Revokes a permission directly assigned to a user.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the user.
 * @param permissionUid - Unique identifier of the permission to revoke.
 * @returns OperationResult (no payload).
 */
export const deleteUserPermission = async (instance: KyInstance, uid: string, permissionUid: string) => {
  try {
    return await instance.delete<OperationResult>(formatString(Uri.users.permissionByUid, uid, permissionUid)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
